import { EventConfigFactory } from './EventConfigFactory';
import { ScheduledRelayCommand4Config } from '@thingslog/repositories/src/scheduledEvents';

export class ScheduledRelayCommand4Factory implements EventConfigFactory {
  public create(deviceNumbers: string[]): ScheduledRelayCommand4Config {
    return {
      '@type': 'SCHEDULED_RELAY_COMMAND_4',
      deviceCommand: 'SCHEDULED_RELAY_COMMAND_4',
      deviceNumbers,
      scheduledRelayCommandParams: [
        {
          relayIndex: 0,
          requiredState: 'OFF',
          hour: 0,
          minutes: 0,
        },
        {
          relayIndex: 0,
          requiredState: 'OFF',
          hour: 0,
          minutes: 0,
        },
        {
          relayIndex: 0,
          requiredState: 'OFF',
          hour: 0,
          minutes: 0,
        },
        {
          relayIndex: 0,
          requiredState: 'OFF',
          hour: 0,
          minutes: 0,
        },
      ],
    };
  }
}
